import { motion, useReducedMotion } from 'framer-motion';

// Sober section entrance: fade + 8px slide. Respects prefers-reduced-motion.
export function SectionReveal({ children, className = '', delay = 0, as = 'div', id }) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      id={id}
      className={className}
      initial={reduce ? false : { opacity: 0, y: 8 }}
      whileInView={reduce ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.4, ease: 'easeOut', delay }}
    >
      {children}
    </MotionTag>
  );
}

export default SectionReveal;
